/**
 * @generated SignedSource<<d7cc38fa8a999a15007a20dbd59696a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreProductExpireBatchActionStatus = "COMPLETED" | "INFO" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchActionList_productExpireBatch$data = {
  readonly actions: ReadonlyArray<{
    readonly id: string;
    readonly status: StoreProductExpireBatchActionStatus;
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchAction_StoreProductExpireBatchAction">;
  }>;
  readonly activeAction: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly product: {
    readonly id: string;
  };
  readonly " $fragmentType": "ProductExpireBatchActionList_productExpireBatch";
};
export type ProductExpireBatchActionList_productExpireBatch$key = {
  readonly " $data"?: ProductExpireBatchActionList_productExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchActionList_productExpireBatch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchActionList_productExpireBatch",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatchAction",
      "kind": "LinkedField",
      "name": "activeAction",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatchAction",
      "kind": "LinkedField",
      "name": "actions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductExpireBatchAction_StoreProductExpireBatchAction"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};
})();

(node as any).hash = "ed6ab7c53be7075c37e428f55030a512";

export default node;
